export function formatCurrency(
  amount,
  withSymbol = true,
  stripDecimals = false
) {
  let formatted = new Intl.NumberFormat("en-CA", {
    currency: "CAD",
    style: "currency",
    currencyDisplay: "code",
  }).format(amount)
  if (!withSymbol) formatted = formatted.substr(withSymbol ? 0 : 1)
  if (stripDecimals) formatted = formatted.substring(0, formatted.indexOf("."))
  return formatted
}

export const NGN_SYMNOL = formatCurrency(0, true, true).substr(0, 1)

export function pluralFormat(amount, singular, plural = null) {
  if (!plural) plural = singular + "s"

  return amount === 1 ? singular : plural
}
